import React, { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api } from "@/lib/api";

export const DEFAULT_FAQS = [
  {
    q: "Do you offer free lessons?",
    a: "No — every lesson is part of a paid course. Each instrument has two complete 10-lesson courses (Beginner→Intermediate and Intermediate→Advanced), so you get a full path with no locked-off previews.",
  },
  {
    q: "How much do the courses cost?",
    a: "Each course is £500 (£50 per lesson) — a full 10-lesson path. Refer a friend after booking: once you've booked a course you get a referral code — when someone you refer signs up with it they save £50 and you get a free 1:1 session with Jason. With a valid code from a member a course is £450 (or £800 for any 2 courses), or take two courses together for £850 (£425 each, save £150). Teachers can buy a class licence for £400 per course after verifying their school email.",
  },
  {
    q: "Can I book a private 1:1 session?",
    a: "Yes. Private 1:1 sessions with Jason are £70 per hour and can be booked from the Pricing page. They're perfect alongside the courses or to focus on a specific goal.",
  },
  {
    q: "Which instruments do you cover?",
    a: "Singers, drummers, guitarists and pianists — with standard notation, guitar TAB and percussion-clef reading where relevant.",
  },
  {
    q: "Do I need to read music already?",
    a: "Not at all. Courses start from the very basics and build up using interactive staves, click-to-play audio and quizzes so your eyes and ears learn together.",
  },
  {
    q: "What if a course isn't right for me?",
    a: "Get in touch within 14 days of purchase via the contact form and we'll make it right.",
  },
  {
    q: "Do you support teachers and schools?",
    a: "Yes — teachers can create classes, set assignments and track student progress, with school-verified class licences available.",
  },
];

export const FAQ = ({ items }) => {
  const [remote, setRemote] = useState(null);
  useEffect(() => {
    api
      .get("/faqs")
      .then(({ data }) => {
        const list = (data.faqs || []).map((f) => ({ q: f.question, a: f.answer }));
        setRemote(list.length ? list : null);
      })
      .catch(() => setRemote(null));
  }, []);
  const faqs = items || remote || DEFAULT_FAQS;
  return (
    <section className="mx-auto max-w-3xl px-4 sm:px-8" data-testid="faq-section">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary">Good to know</p>
      <h2 className="mt-2 font-serif text-3xl sm:text-4xl">Frequently asked questions</h2>
      <Accordion type="single" collapsible className="mt-6">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left font-medium">{f.q}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export default FAQ;
